(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ltp-page-hero')) {
    customElements.define('ltp-page-hero', class extends HTMLElement {
      connectedCallback() {
        const firstSection = document.querySelector('#MainContent > .shopify-section');
        if (!firstSection || this.closest('.shopify-section') !== firstSection) {
          this.removeAttribute('data-ltp-viewport-hero');
          return;
        }
        this.setAttribute('data-ltp-viewport-hero', '');
        this.headerSections = [...document.querySelectorAll('.shopify-section-group-header-group')];
        this.updateHeaderSpace = () => {
          const height = this.headerSections.reduce((total, section) => total + section.offsetHeight, 0);
          this.style.setProperty('--ltp-page-header-space', `${height}px`);
        };
        this.updateHeaderSpace();
        if ('ResizeObserver' in window) {
          this.headerObserver = new ResizeObserver(this.updateHeaderSpace);
          this.headerSections.forEach(section => this.headerObserver.observe(section));
        }
        window.addEventListener('resize', this.updateHeaderSpace, { passive: true });
      }

      disconnectedCallback() {
        this.headerObserver?.disconnect();
        window.removeEventListener('resize', this.updateHeaderSpace);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ltp-about-chapter"] && !Shopify.designMode) return;
  try {
    

(() => {
  if (customElements.get('ltp-about-film')) return;
  const films = new Map();
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const saveData = navigator.connection && navigator.connection.saveData;
  let current;
  const stop = (film) => {
    if (!film) return;
    film.querySelector('video')?.pause();
    film.removeAttribute('data-playing');
  };
  const select = () => {
    const next = motion.matches || saveData || document.hidden ? null : [...films]
      .filter(([film, ratio]) => film.isConnected && ratio > 0.25)
      .sort((a, b) => b[1] - a[1])[0]?.[0];
    if (current === next) return;
    stop(current);
    current = next;
    if (!next) return;
    const video = next.querySelector('video');
    if (!video) return;
    if (!video.dataset.loaded) {
      const options = [...video.querySelectorAll('source[data-src]')].sort((a,b) => Number(a.dataset.width)-Number(b.dataset.width));
      const desired = Math.min(1600, next.clientWidth * Math.min(window.devicePixelRatio || 1, 1.5));
      const source = options.find(s => Number(s.dataset.width) >= desired) || options[options.length-1];
      if (!source) return;
      video.src = source.dataset.src;
      video.dataset.loaded = 'true';
      video.load();
    }
    video.muted = true;
    video.play().then(() => { if (current === next && !motion.matches) next.setAttribute('data-playing',''); else stop(next); }).catch(() => stop(next));
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => films.set(entry.target, entry.intersectionRatio));
    select();
  }, {threshold:[0,0.25,0.5,0.75,1]}) : null;
  class AboutFilm extends HTMLElement {
    connectedCallback() { films.set(this,0); observer?.observe(this); }
    disconnectedCallback() { observer?.unobserve(this); films.delete(this); stop(this); if (current === this) current = null; select(); }
  }
  customElements.define('ltp-about-film', AboutFilm);
  motion.addEventListener('change',select);
  document.addEventListener('visibilitychange',select);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ltp-home-about"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('ltp-home-about')) return;
  class HomeAbout extends HTMLElement {
    connectedCallback() {
      if (this.observer || !window.matchMedia || !('IntersectionObserver' in window)) return;
      this.preference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.film = this.querySelector('.ltp-home-about__film');
      this.video = this.querySelector('video');
      this.visible = false;
      this.onPreference = () => this.syncVideo();
      this.onVisibility = () => this.syncVideo();
      this.onVideoError = () => { this.failed = true; this.stopVideo(); };
      this.preference.addEventListener('change', this.onPreference);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.video?.addEventListener('error', this.onVideoError);
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.target === this.film) {
            this.visible = entry.isIntersecting && entry.intersectionRatio > .15;
            this.syncVideo();
          }
        });
      }, {threshold:[0,.15,.25]});
      if (this.film) this.observer.observe(this.film);
    }
    canPlay() {
      return this.video && this.isConnected && this.visible && !this.failed && !this.preference.matches && !document.hidden && !navigator.connection?.saveData;
    }
    syncVideo() {
      if (!this.canPlay()) { this.stopVideo(); return; }
      const video = this.video;
      if (!video.dataset.loaded) {
        const allSources = [...video.querySelectorAll('source[data-src]')];
        const mobileSources = allSources.filter(item => item.dataset.profile === 'mobile');
        const candidates = window.matchMedia('(max-width:749px)').matches && mobileSources.length ? mobileSources : allSources.filter(item => item.dataset.profile !== 'mobile');
        const sources = candidates.sort((a,b) => Number(a.dataset.width)-Number(b.dataset.width));
        const desired = Math.min(960, this.film.clientWidth * Math.min(window.devicePixelRatio || 1, 1.5));
        const source = sources.find(item => Number(item.dataset.width) >= desired) || sources[sources.length-1];
        if (!source) return;
        const poster = this.querySelector('.ltp-home-about__poster');
        if (poster) video.poster = poster.currentSrc || poster.src;
        video.src = source.dataset.src;
        video.dataset.loaded = 'true';
        video.load();
      }
      video.muted = true;
      video.play().then(() => { if (this.canPlay()) this.film.setAttribute('data-playing',''); else this.stopVideo(); }).catch(() => this.stopVideo());
    }
    stopVideo() {
      this.video?.pause();
      this.film?.removeAttribute('data-playing');
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
      this.stopVideo();
      this.preference?.removeEventListener('change', this.onPreference);
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.video?.removeEventListener('error', this.onVideoError);
    }
  }
  customElements.define('ltp-home-about', HomeAbout);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ltp-market-capture"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-ltp-market-root]');
    roots.forEach((root) => {
      if (root.dataset.marketReady === 'true') return;
      root.dataset.marketReady = 'true';

      let marketName = '';
      let marketDate = '';
      const liveWriteEnabled = root.dataset.enableLiveWrite === 'true';
      const publicId = root.dataset.klaviyoPublicId.trim();
      const listId = root.dataset.klaviyoListId.trim();
      const apiRevision = root.dataset.klaviyoApiRevision.trim();
      const formHost = root.querySelector('[data-market-form]');
      const nativeForm = root.querySelector('[data-native-market-form]');
      const success = root.querySelector('[data-market-success]');
      const interestPanel = root.querySelector('[data-interest-panel]');
      const lookup = root.querySelector('[data-lookup]');
      const searchLabel = root.querySelector('[data-search-label]');
      const search = root.querySelector('[data-market-search]');
      const results = root.querySelector('[data-market-results]');
      const selectedCopy = root.querySelector('[data-selected-copy]');
      const browsingCopy = root.querySelector('[data-browsing-copy]');
      const status = root.querySelector('[data-market-status]');
      const firstName = root.querySelector('[data-market-first-name]');
      const email = root.querySelector('[data-market-email]');
      const firstNameError = root.querySelector('[data-first-name-error]');
      const emailError = root.querySelector('[data-email-error]');
      const submit = root.querySelector('[data-market-submit]');
      const submitLabel = root.querySelector('[data-submit-label]');
      const submitStatus = root.querySelector('[data-submit-status]');
      const marketNameField = root.querySelector('[data-market-name]');
      const marketDateField = root.querySelector('[data-market-date]');
      const interestTypeField = root.querySelector('[data-interest-type]');
      const interestTitleField = root.querySelector('[data-interest-title]');
      const interestUrlField = root.querySelector('[data-interest-url]');
      const resetButton = root.querySelector('[data-market-reset]');
      const radios = root.querySelectorAll('.ltp-market__option input[type="radio"]');
      let selected = null;
      let searchTimer = null;
      let inactivityTimer = null;
      let resetScheduled = false;
      let submitting = false;
      let pendingSubmission = null;
      let activeRequestController = null;
      let submissionRun = 0;

      const messages = {
        artworkPrompt: root.dataset.msgArtworkPrompt,
        artworkEmpty: root.dataset.msgArtworkEmpty,
        collectionPrompt: root.dataset.msgCollectionPrompt,
        collectionEmpty: root.dataset.msgCollectionEmpty,
        searchError: root.dataset.msgSearchError,
        selectError: root.dataset.msgSelectError,
        resultError: root.dataset.msgResultError,
        missingMarket: root.dataset.msgMissingMarket,
        artworkLabel: root.dataset.msgArtworkLabel,
        artworkPlaceholder: root.dataset.msgArtworkPlaceholder,
        collectionLabel: root.dataset.msgCollectionLabel,
        collectionPlaceholder: root.dataset.msgCollectionPlaceholder,
        selectedPrefix: root.dataset.msgSelectedPrefix,
        browsingTitle: root.dataset.msgBrowsingTitle,
        firstNameError: root.dataset.msgFirstNameError,
        emailError: root.dataset.msgEmailError,
        submitError: root.dataset.msgSubmitError,
        renderOnly: root.dataset.msgRenderOnly,
        processing: root.dataset.msgProcessing
      };

      const refreshMarketConfig = () => {
        const currentParams = new URLSearchParams(window.location.search);
        marketName = (currentParams.get(root.dataset.marketParam) || '').trim().slice(0, 120);
        marketDate = (currentParams.get(root.dataset.dateParam) || '').trim().slice(0, 64);
        if (marketName && status.textContent === messages.missingMarket) status.textContent = '';
      };

      const canonicalStorefrontOrigin = 'https://ltpco.com.au';

      const normaliseUrl = (value) => {
        try {
          const parsedUrl = new URL(value, window.location.origin);
          if (parsedUrl.protocol !== 'http:' && parsedUrl.protocol !== 'https:') return '';
          return new URL(parsedUrl.pathname, canonicalStorefrontOrigin).href;
        } catch (error) {
          return '';
        }
      };

      const createUniqueId = () => {
        if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
        return 'market-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
      };

      const redactPendingSubmission = () => {
        if (!pendingSubmission) return;
        pendingSubmission.firstName = '';
        pendingSubmission.email = '';
        pendingSubmission.properties = null;
        pendingSubmission = null;
      };

      const cancelActiveRequest = () => {
        if (activeRequestController) activeRequestController.abort();
        activeRequestController = null;
      };

      const resetFieldError = (field, errorElement) => {
        field.removeAttribute('aria-invalid');
        errorElement.textContent = '';
        errorElement.hidden = true;
      };

      const resetValidation = () => {
        resetFieldError(firstName, firstNameError);
        resetFieldError(email, emailError);
        submitStatus.textContent = '';
        submitStatus.hidden = true;
      };

      const setHiddenField = (field, value) => {
        field.value = value;
        field.defaultValue = value;
        field.setAttribute('value', value);
      };

      const setSubmitting = (isSubmitting) => {
        submitting = isSubmitting;
        submit.disabled = isSubmitting;
        submit.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');
        submitLabel.textContent = isSubmitting ? messages.processing : submit.dataset.defaultLabel;
      };

      const hasCustomerState = () => {
        if (root.querySelector('input[type="radio"]:checked') || selected || search.value.trim()) return true;
        return firstName.value.trim() !== '' || email.value.trim() !== '';
      };

      const fadeAndReload = (delay) => {
        if (resetScheduled) return;
        resetScheduled = true;
        window.setTimeout(() => {
          root.classList.add('ltp-market--resetting');
          window.setTimeout(() => window.location.reload(), 260);
        }, delay);
      };

      const scheduleInactivityReset = () => {
        window.clearTimeout(inactivityTimer);
        if (!hasCustomerState() || resetScheduled) return;
        inactivityTimer = window.setTimeout(() => {
          clearCustomerState({ showSuccess: false });
          fadeAndReload(0);
        }, 90000);
      };

      const clearCustomerState = ({ showSuccess }) => {
        submissionRun += 1;
        cancelActiveRequest();
        window.clearTimeout(searchTimer);
        window.clearTimeout(inactivityTimer);
        redactPendingSubmission();
        selected = null;
        search.value = '';
        search.blur();
        firstName.value = '';
        email.value = '';
        firstName.blur();
        email.blur();
        results.replaceChildren();
        search.setAttribute('aria-expanded', 'false');
        radios.forEach((radio) => {
          radio.checked = false;
        });
        lookup.hidden = true;
        selectedCopy.hidden = true;
        selectedCopy.textContent = '';
        browsingCopy.hidden = true;
        status.textContent = '';
        setHiddenField(interestTypeField, '');
        setHiddenField(interestTitleField, '');
        setHiddenField(interestUrlField, '');
        refreshMarketConfig();
        setHiddenField(marketNameField, marketName);
        setHiddenField(marketDateField, marketDate);
        resetValidation();
        setSubmitting(false);
        if (showSuccess) {
          interestPanel.hidden = true;
          formHost.hidden = false;
          nativeForm.hidden = true;
          success.hidden = false;
        } else {
          interestPanel.hidden = false;
          formHost.hidden = true;
          nativeForm.hidden = false;
          success.hidden = true;
        }
      };

      const syncFields = () => {
        refreshMarketConfig();
        const checked = root.querySelector('input[type="radio"]:checked');
        setHiddenField(marketNameField, marketName);
        setHiddenField(marketDateField, marketDate);
        setHiddenField(interestTypeField, checked ? checked.value : '');
        setHiddenField(interestTitleField, selected ? selected.title : checked && checked.value === 'browsing' ? messages.browsingTitle : '');
        setHiddenField(interestUrlField, selected ? normaliseUrl(selected.url) : checked && checked.value === 'browsing' ? normaliseUrl(root.dataset.defaultInterestUrl) : '');
      };

      const revealCustomerForm = () => {
        formHost.hidden = false;
        nativeForm.hidden = false;
        success.hidden = true;
        syncFields();
      };

      const invalidatePendingSubmission = () => {
        if (!submitting) redactPendingSubmission();
      };

      const renderResults = (items, type) => {
        results.replaceChildren();
        if (!items.length) {
          status.textContent = type === 'collection' ? messages.collectionEmpty : messages.artworkEmpty;
          search.setAttribute('aria-expanded', 'false');
          return;
        }
        status.textContent = '';
        items.forEach((item) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'ltp-market__result';
          button.setAttribute('role', 'option');
          button.setAttribute('aria-selected', selected && selected.url === item.url ? 'true' : 'false');
          button.textContent = item.title;
          button.addEventListener('click', () => {
            invalidatePendingSubmission();
            selected = item;
            search.value = item.title;
            results.replaceChildren();
            search.setAttribute('aria-expanded', 'false');
            selectedCopy.textContent = messages.selectedPrefix + ' ' + item.title;
            selectedCopy.hidden = false;
            status.textContent = '';
            revealCustomerForm();
            scheduleInactivityReset();
          });
          results.appendChild(button);
        });
        search.setAttribute('aria-expanded', 'true');
      };

      const runSearch = async () => {
        const checked = root.querySelector('input[type="radio"]:checked');
        const query = search.value.trim();
        if (!checked || checked.value === 'browsing' || query.length < 2) {
          results.replaceChildren();
          search.setAttribute('aria-expanded', 'false');
          status.textContent = query.length ? checked && checked.value === 'collection' ? messages.collectionPrompt : messages.artworkPrompt : '';
          return;
        }
        const resourceType = checked.value === 'collection' ? 'collection' : 'product';
        const endpoint = window.Shopify.routes.root + 'search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=' + resourceType + '&resources[limit]=8&resources[options][unavailable_products]=hide';
        try {
          const response = await fetch(endpoint, { headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('search');
          const payload = await response.json();
          const group = resourceType === 'collection' ? payload.resources.results.collections : payload.resources.results.products;
          renderResults((group || []).map((item) => ({ title: item.title, url: item.url })), checked.value);
        } catch (error) {
          results.replaceChildren();
          search.setAttribute('aria-expanded', 'false');
          status.textContent = messages.searchError;
        }
      };

      radios.forEach((radio) => {
        radio.addEventListener('change', () => {
          invalidatePendingSubmission();
          selected = null;
          search.value = '';
          results.replaceChildren();
          selectedCopy.hidden = true;
          selectedCopy.textContent = '';
          status.textContent = '';
          const browsing = radio.value === 'browsing';
          lookup.hidden = browsing;
          browsingCopy.hidden = !browsing;
          formHost.hidden = !browsing;
          if (radio.value === 'collection') {
            searchLabel.textContent = messages.collectionLabel;
            search.placeholder = messages.collectionPlaceholder;
          } else {
            searchLabel.textContent = messages.artworkLabel;
            search.placeholder = messages.artworkPlaceholder;
          }
          syncFields();
          if (browsing) revealCustomerForm();
          if (!browsing) search.focus();
          scheduleInactivityReset();
        });
      });

      search.addEventListener('input', () => {
        invalidatePendingSubmission();
        selected = null;
        selectedCopy.hidden = true;
        selectedCopy.textContent = '';
        formHost.hidden = true;
        syncFields();
        window.clearTimeout(searchTimer);
        searchTimer = window.setTimeout(runSearch, 220);
      });

      const validateCustomerFields = () => {
        resetValidation();
        firstName.value = firstName.value.trim();
        email.value = email.value.trim().toLowerCase();
        let valid = true;
        if (!firstName.value) {
          firstName.setAttribute('aria-invalid', 'true');
          firstNameError.textContent = messages.firstNameError;
          firstNameError.hidden = false;
          valid = false;
        }
        if (!email.value || !email.validity.valid) {
          email.setAttribute('aria-invalid', 'true');
          emailError.textContent = messages.emailError;
          emailError.hidden = false;
          valid = false;
        }
        if (!valid) {
          const firstInvalid = nativeForm.querySelector('[aria-invalid="true"]');
          if (firstInvalid) firstInvalid.focus();
        }
        return valid;
      };

      const buildPendingSubmission = () => {
        const checked = root.querySelector('input[type="radio"]:checked');
        return {
          uniqueId: createUniqueId(),
          firstName: firstName.value,
          email: email.value,
          subscriptionAccepted: false,
          properties: {
            acquisition_source: 'Market',
            market_name: marketName,
            market_date: marketDate,
            interest_type: checked ? checked.value : '',
            interest_title: selected ? selected.title : checked && checked.value === 'browsing' ? messages.browsingTitle : '',
            interest_url: selected ? normaliseUrl(selected.url) : checked && checked.value === 'browsing' ? normaliseUrl(root.dataset.defaultInterestUrl) : ''
          }
        };
      };

      const createSubscriptionPayload = (submission) => ({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'LTP.Co Market iPad capture',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: submission.email,
                  first_name: submission.firstName,
                  subscriptions: {
                    email: {
                      marketing: {
                        consent: 'SUBSCRIBED'
                      }
                    }
                  }
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: listId
              }
            }
          }
        }
      });

      const createEventPayload = (submission) => ({
        data: {
          type: 'event',
          attributes: {
            metric: {
              data: {
                type: 'metric',
                attributes: {
                  name: 'LTP Acquisition Submitted'
                }
              }
            },
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: submission.email,
                  first_name: submission.firstName
                }
              }
            },
            properties: submission.properties,
            unique_id: submission.uniqueId
          }
        }
      });

      const postToKlaviyo = async (path, payload) => {
        activeRequestController = new AbortController();
        const requestController = activeRequestController;
        const timeout = window.setTimeout(() => requestController.abort(), 15000);
        try {
          const response = await fetch('https://a.klaviyo.com/client/' + path + '?company_id=' + encodeURIComponent(publicId), {
            method: 'POST',
            mode: 'cors',
            credentials: 'omit',
            cache: 'no-store',
            headers: {
              Accept: 'application/vnd.api+json',
              'Content-Type': 'application/vnd.api+json',
              revision: apiRevision
            },
            body: JSON.stringify(payload),
            signal: requestController.signal
          });
          if (response.status !== 202) throw new Error('submission');
        } finally {
          window.clearTimeout(timeout);
          if (activeRequestController === requestController) activeRequestController = null;
        }
      };

      const showSubmitError = (message) => {
        if (pendingSubmission) {
          firstName.value = pendingSubmission.firstName;
          email.value = pendingSubmission.email;
        }
        submitStatus.textContent = message;
        submitStatus.hidden = false;
        setSubmitting(false);
      };

      const showSuccess = () => {
        clearCustomerState({ showSuccess: true });
        root.dataset.lastSubmissionResult = liveWriteEnabled ? 'accepted' : 'simulated-success';
        success.focus({ preventScroll: true });
        fadeAndReload(5500);
      };

      const handleSubmit = async (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        if (submitting || resetScheduled) return;
        refreshMarketConfig();
        const checked = root.querySelector('input[type="radio"]:checked');
        if (!marketName) {
          status.textContent = messages.missingMarket;
          return;
        }
        if (!checked) {
          status.textContent = messages.selectError;
          return;
        }
        if (checked.value !== 'browsing' && !selected) {
          status.textContent = messages.resultError;
          search.focus();
          return;
        }
        syncFields();
        if (!validateCustomerFields()) return;

        setSubmitting(true);
        submitStatus.hidden = true;
        if (!pendingSubmission) pendingSubmission = buildPendingSubmission();
        const run = ++submissionRun;

        if (!liveWriteEnabled) {
          await new Promise((resolve) => window.setTimeout(resolve, 320));
          if (run !== submissionRun) return;
          const qaMode = (new URLSearchParams(window.location.search).get('ltp_market_qa') || '').trim().toLowerCase();
          if (qaMode === 'success') {
            showSuccess();
          } else {
            root.dataset.lastSubmissionResult = qaMode === 'error' ? 'simulated-error' : 'render-only-blocked';
            showSubmitError(qaMode === 'error' ? messages.submitError : messages.renderOnly);
          }
          return;
        }

        if (!publicId || !listId || !apiRevision) {
          root.dataset.lastSubmissionResult = 'configuration-error';
          showSubmitError(messages.submitError);
          return;
        }

        try {
          if (!pendingSubmission.subscriptionAccepted) {
            await postToKlaviyo('subscriptions', createSubscriptionPayload(pendingSubmission));
            if (run !== submissionRun) return;
            pendingSubmission.subscriptionAccepted = true;
          }
          await postToKlaviyo('events', createEventPayload(pendingSubmission));
          if (run !== submissionRun) return;
          showSuccess();
        } catch (error) {
          if (run !== submissionRun) return;
          root.dataset.lastSubmissionResult = 'error';
          showSubmitError(messages.submitError);
        }
      };

      nativeForm.addEventListener('submit', handleSubmit, true);

      [firstName, email].forEach((field) => {
        field.addEventListener('input', () => {
          invalidatePendingSubmission();
          if (field === firstName) resetFieldError(firstName, firstNameError);
          if (field === email) resetFieldError(email, emailError);
          submitStatus.hidden = true;
        });
      });

      ['pointerdown', 'keydown', 'input', 'change'].forEach((eventName) => {
        root.addEventListener(eventName, scheduleInactivityReset, { passive: true });
      });

      resetButton.addEventListener('click', () => {
        clearCustomerState({ showSuccess: false });
        fadeAndReload(0);
      });

      submit.dataset.defaultLabel = submitLabel.textContent;
      syncFields();
      if (!marketName) status.textContent = messages.missingMarket;
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
